export const HELP_DESK_COMMENT_REPLY_SYSTEM_MESSAGE = 'HELP_DESK_COMMENT_REPLY_SYSTEM_MESSAGE';